module.exports = __webpack_public_path__ + "media/dota2.cdb81065.mp4";